export enum CostBasisMethods {
  AVERAGE_COST = 'AvgCost',
  FIFO = 'FIFO',
  HIFO = 'HIFO',
  MIN_TAX = 'MinTax',
  SPECID = 'SpecID',
  NONE = '',
}
